var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeKidsSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 3750,
    height: 3750,
    viewBox: "0 0 3750 3750",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(100%, 0%, 0%)",
    fillOpacity: 1,
    d: "M 1531.378906 1191.738281 L 2411.929688 1191.738281 C 2736.53125 1191.738281 2997.859375 1453.058594 2997.859375 1777.671875 L 2997.859375 2038.308594 C 2997.859375 2362.910156 2736.53125 2624.238281 2411.929688 2624.238281 L 1531.378906 2624.238281 C 1206.769531 2624.238281 945.445312 2362.910156 945.445312 2038.308594 L 945.445312 1777.671875 C 945.445312 1453.058594 1206.769531 1191.738281 1531.378906 1191.738281 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(100%, 100%, 100%)",
    fillOpacity: 1,
    d: "M 1766.289062 2181.75 C 1685.488281 2135.648438 1683.191406 1681.441406 1763.53125 1634.519531 C 1843.859375 1587.589844 2238.359375 1812.710938 2238.828125 1905.738281 C 2239.300781 1998.769531 1847.089844 2227.859375 1766.289062 2181.75 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeKidsSvgrepoCom);
export default __webpack_public_path__ + "static/media/youtube-kids-svgrepo-com.0c0f68369e8725ad8e27520a3c2b9420.svg";
export { ForwardRef as ReactComponent };